
/**
 * @file In-app Event 应用内事件数据
 */
import {
  durationFormatter,
  percentTextFormatter,
  integerValueFormatter,
  moneyFormatterWithUnit,
} from 'src/const/statistics/formatters';
import { EVENT_ATTRIBUTE } from 'src/const/statistics/metrics-emun';

// 当前在 Reporting 页面
const isInReportingModule = () => window.location.href.includes('reporting');

export const EnumInAppEventData = [
  {
    i18nPath: 'common_in_app_event_active', // NOTE: 非对回的active也要保留
    key: 'event_active', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_active',
    onlyForUniq: true, // 只对 Uniq 事件可用
    children: [
      {
        i18nPath: 'common_in_app_event_active_count', // 次数
        key: 'active', // {metric}
        hint: 'campaign_hover_stat_data.active',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_cost_per_active', // 单次消耗
        key: 'active_cost', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_active',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'active_rate', // {metric}_per_install
        disabled: true,
      },
      {
        key: 'value_per_active', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'total_active_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_time_attr_active', // 事件父节点
    key: 'time_attr_event_active', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.time_attr_event_active',
    onlyForUniq: true, // 只对 Uniq 事件可用
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_active_count', // 次数
        key: 'time_attr_active', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_active',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        itemIndex: 1,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_active', // 单次消耗
        key: 'time_attr_active_cost', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_active',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        itemIndex: 0,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_active_rate', // {metric}_per_install
        disabled: true,
      },
      {
        key: 'time_attr_value_per_active', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_active_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_active_register', // 事件父节点
    key: 'event_active_register', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_active_register',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_active_register_count', // 次数
        key: 'time_attr_active_register', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_active_register',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_active_register', // 单次消耗
        key: 'time_attr_active_register_cost', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_active_register',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_active_register_per_install', // 频率
        key: 'time_attr_active_register_rate', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_active_register_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_active_register',
        key: 'time_attr_repetitive_active_register',
        hint: 'campaign_hover_stat_data.time_attr_repetitive_active_register',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_active_register',
        key: 'time_attr_cost_per_repetitive_active_register',
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_active_register',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        // textFormatter: moneyUnitFormatter,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_active_register', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_active_register_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_active_pay', // 事件父节点
    key: 'event_active_pay', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_active_pay',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_active_pay_count', // 次数
        key: 'time_attr_active_pay', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_active_pay',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_active_pay', // 单次消耗
        key: 'time_attr_active_pay_cost', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_active_pay',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_active_pay_per_install', // 频率
        key: 'time_attr_active_pay_rate', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_active_pay_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_active_pay',
        key: 'time_attr_repetitive_active_pay',
        hint: 'campaign_hover_stat_data.time_attr_repetitive_active_pay',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_active_pay',
        key: 'time_attr_cost_per_repetitive_active_pay',
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_active_pay',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_active_pay', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_active_pay', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_active_pay',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_active_pay_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_active_pay_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_active_pay_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_roas', // ROAS
        key: 'time_attr_repetitive_active_pay_roas', // {metric}
        hint: 'campaign_hover_stat_data.roas',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        hide: () => !isInReportingModule(), // 只在 Reporting 披露
        formatter: integerValueFormatter, // 格式化表格数据
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_roas', // 事件父节点
    key: 'event_in_roas', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.roas',
    onlyForEach: true, // 只对 Each 事件可用
    hide: () => isInReportingModule(), // 只在 列表 披露
    children: [
      {
        i18nPath: 'common_in_app_event_roas', // 次数
        key: 'time_attr_repetitive_active_pay_roas', // {metric}
        hint: 'campaign_hover_stat_data.roas',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        disabled: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        key: 'event_active_roas_cost_per_roas', // cost_per_{metric}
        disabled: true,
      },
      {
        key: 'event_active_roas_roas_per_install', // {metric}_per_install
        disabled: true,
      },
      {
        i18nPath: 'common_in_app_event_roas',
        key: 'time_attr_repetitive_active_pay_roas',
        hint: 'campaign_hover_stat_data.roas',
        hoverKey: 'campaign_hover_stat_data.roas',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: durationFormatter,
      },
      {
        key: 'time_attr_cost_per_repetitive_roas',
        disabled: true,
      },
      {
        key: 'time_attr_value_per_repetitive_roas', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_repetitive_roas_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_in_app_cart', // 事件父节点
    key: 'event_in_app_cart', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_cart',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_cart_count', // 次数
        key: 'time_attr_in_app_cart', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_in_app_cart',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_in_app_cart', // 单次消耗
        key: 'time_attr_cost_per_in_app_cart', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_in_app_cart',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_cart_per_install', // 频率
        key: 'time_attr_in_app_cart_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_in_app_cart_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_in_app_cartt',
        key: 'time_attr_repetitive_in_app_cart',
        hint: 'campaign_hover_stat_data.time_attr_repetitive_in_app_cart',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: integerValueFormatter,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_in_app_cart',
        key: 'time_attr_cost_per_repetitive_in_app_cart',
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_in_app_cart',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_in_app_cart', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_in_app_cart', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_in_app_cart',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_in_app_cart_valuee', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_in_app_cart_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_in_app_cart_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_in_app_order', // 事件父节点
    key: 'event_in_app_order', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_order',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_order_count', // 次数
        key: 'time_attr_in_app_order', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_in_app_order',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_in_app_order', // 单次消耗
        key: 'time_attr_cost_per_in_app_order', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_in_app_order',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_order_per_install', // 频率
        key: 'time_attr_in_app_order_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_in_app_order_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_in_app_order', // 次数
        key: 'time_attr_repetitive_in_app_order', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_in_app_order',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_in_app_order', // 单次消耗
        key: 'time_attr_cost_per_repetitive_in_app_order', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_in_app_order',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_in_app_order', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_in_app_order', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_in_app_order',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_in_app_order_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_in_app_order_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_in_app_order_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_in_app_detail_uv', // 事件父节点
    key: 'event_in_app_detail_uv', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_detail_uv',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_detail_uv_count', // 次数
        key: 'time_attr_in_app_detail_uv', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_in_app_detail_uv',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_in_app_detail_uv', // 单次消耗
        key: 'time_attr_cost_per_in_app_detail_uv', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_in_app_detail_uv',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_detail_uv_per_install', // 频率
        key: 'time_attr_in_app_detail_uv_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_in_app_detail_uv_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_in_app_detail_uv', // 次数
        key: 'time_attr_repetitive_in_app_detail_uv', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_in_app_detail_uv',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_in_app_detail_uv', // 单次消耗
        key: 'time_attr_cost_per_repetitive_in_app_detail_uv', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_in_app_detail_uv',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_in_app_detail_uv', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_in_app_detail_uv', // value_per_{metric}
        hint: 'campaign_hover_stat_data.value_per_repetitive_in_app_detail_uv',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_in_app_detail_uv_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_in_app_detail_uv_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_in_app_detail_uv_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_next_day_open', // 事件父节点
    key: 'event_next_day_open', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_next_day_open',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_next_day_open_count', // 次数
        key: 'time_attr_next_day_open', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_next_day_open',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_next_day_open', // 单次消耗
        key: 'time_attr_cost_per_next_day_open', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_next_day_open',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_next_day_open_per_install', // 频率
        key: 'time_attr_next_day_open_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_next_day_open_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_next_day_open', // 次数
        key: 'time_attr_repetitive_next_day_open', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_next_day_open',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_next_day_open', // 单次消耗
        key: 'time_attr_cost_per_repetitive_next_day_open', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_next_day_open',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_next_day_open', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_next_day_open_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_add_payment_info', // 事件父节点
    key: 'event_add_payment_info', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_add_payment_info',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_add_payment_info_count', // 次数
        key: 'time_attr_add_payment_info', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_add_payment_info',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_add_payment_info', // 单次消耗
        key: 'time_attr_cost_per_add_payment_info', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_add_payment_info',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_add_payment_info_per_install', // 频率
        key: 'time_attr_add_payment_info_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_add_payment_info_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_add_payment_info', // 次数
        key: 'time_attr_repetitive_add_payment_info', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_add_payment_info',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_add_payment_info', // 单次消耗
        key: 'time_attr_cost_per_repetitive_add_payment_info', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_add_payment_info',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_add_payment_info', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_add_payment_info_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_add_to_wishlist', // 事件父节点
    key: 'event_add_to_wishlist', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_add_to_wishlist',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_add_to_wishlist_count', // 次数
        key: 'time_attr_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_add_to_wishlist', // 单次消耗
        key: 'time_attr_cost_per_add_to_wishlist', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_add_to_wishlist_per_install', // 频率
        key: 'time_attr_add_to_wishlist_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_add_to_wishlist_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_add_to_wishlist', // 次数
        key: 'time_attr_repetitive_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_add_to_wishlist', // 单次消耗
        key: 'time_attr_cost_per_repetitive_add_to_wishlist', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_add_to_wishlist', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_add_to_wishlist', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_add_to_wishlist_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_add_to_wishlist_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_add_to_wishlist_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_launch_app', // 事件父节点
    key: 'event_launch_app', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_launch_app',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_launch_app_count', // 次数
        key: 'time_attr_launch_app', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_launch_app',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_launch_app', // 单次消耗
        key: 'time_attr_cost_per_launch_app', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_launch_app',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_launch_app_per_install', // 频率
        key: 'time_attr_launch_app_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_launch_app_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_launch_app', // 次数
        key: 'time_attr_repetitive_launch_app', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_launch_app',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_launch_app', // 单次消耗
        key: 'time_attr_cost_per_repetitive_launch_app', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_launch_app',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_launch_app', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_launch_app_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_complete_tutorial', // 事件父节点
    key: 'event_complete_tutorial', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_complete_tutorial',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_complete_tutorial_count', // 次数
        key: 'time_attr_complete_tutorial', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_complete_tutorial',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_complete_tutorial', // 单次消耗
        key: 'time_attr_cost_per_complete_tutorial', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_complete_tutorial',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_complete_tutorial_per_install', // 频率
        key: 'time_attr_complete_tutorial_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_complete_tutorial_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_complete_tutorial', // 次数
        key: 'time_attr_repetitive_complete_tutorial', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_complete_tutorial',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_complete_tutorial', // 单次消耗
        key: 'time_attr_cost_per_repetitive_complete_tutorial', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_complete_tutorial',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_complete_tutorial', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_complete_tutorial', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_complete_tutorial',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_complete_tutorial_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_complete_tutorial_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_complete_tutorial_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_create_group', // 事件父节点
    key: 'event_create_group', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_create_group',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_create_group_count', // 次数
        key: 'time_attr_create_group', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_create_group',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_create_group', // 单次消耗
        key: 'time_attr_cost_per_create_group', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_create_group',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_create_group_per_install', // 频率
        key: 'time_attr_create_group_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_create_group_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_create_group', // 次数
        key: 'time_attr_repetitive_create_group', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_create_group',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_create_group', // 单次消耗
        key: 'time_attr_cost_per_repetitive_create_group', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_create_group',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_create_groupp', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_create_group', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_create_group',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_create_group_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_create_group_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_create_group_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_join_group', // 事件父节点
    key: 'event_join_group', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_join_group',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_join_group_count', // 次数
        key: 'time_attr_join_group', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_join_group',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_join_group', // 单次消耗
        key: 'time_attr_cost_per_join_group', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_join_group',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_join_group_per_install', // 频率
        key: 'time_attr_join_group_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_join_group_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_join_group', // 次数
        key: 'time_attr_repetitive_join_group', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_join_group',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_join_group', // 单次消耗
        key: 'time_attr_cost_per_repetitive_join_group', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_join_group',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_join_group', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_join_group', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_join_group',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_join_group_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_join_group_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_join_group_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_create_gamerole', // 事件父节点
    key: 'event_create_gamerole', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_create_gamerole',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_create_gamerole_count', // 次数
        key: 'time_attr_create_gamerole', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_create_gamerole',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_create_gamerole', // 单次消耗
        key: 'time_attr_cost_per_create_gamerole', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_create_gamerole',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_create_gamerole_per_install', // 频率
        key: 'time_attr_create_gamerole_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_create_gamerole_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_create_gamerole', // 次数
        key: 'time_attr_repetitive_create_gamerole', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_create_gamerole',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_create_gamerole', // 单次消耗
        key: 'time_attr_cost_per_repetitive_create_gamerole', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_create_gamerole',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_create_gamerole', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_create_gamerole', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_create_gamerole',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_create_gamerole_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_create_gamerole_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_create_gamerole_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_spend_credits', // 事件父节点
    key: 'event_spend_credits', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_spend_credits',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_spend_credits_count', // 次数
        key: 'time_attr_spend_credits', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_spend_credits',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_spend_credits', // 单次消耗
        key: 'time_attr_cost_per_spend_credits', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_spend_credits',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_spend_credits_per_install', // 频率
        key: 'time_attr_spend_credits_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_spend_credits_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_spend_credits', // 次数
        key: 'time_attr_repetitive_spend_credits', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_spend_credits',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_spend_credits', // 单次消耗
        key: 'time_attr_cost_per_repetitive_spend_credits', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_spend_credits',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_spend_credits', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_spend_credits', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_spend_credits',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_spend_credits_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_spend_credits_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_spend_credits_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_update_level', // 事件父节点
    key: 'event_update_level', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_update_level',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_update_level_count', // 次数
        key: 'time_attr_update_level', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_update_level',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_update_level', // 单次消耗
        key: 'time_attr_cost_per_update_level', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_update_level',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_update_level_per_install', // 频率
        key: 'time_attr_update_level_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_update_level_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_eventtime_attr_repetitive_update_level', // 次数
        key: 'time_attr_repetitive_update_level', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_update_level',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_update_level', // 单次消耗
        key: 'time_attr_cost_per_repetitive_update_level', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_update_level',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_update_level', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_update_level', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_update_level',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_update_level_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_update_level_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_update_level_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_unlock_achievement', // 事件父节点
    key: 'event_unlock_achievement', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_unlock_achievement',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_unlock_achievement_count', // 次数
        key: 'time_attr_unlock_achievement', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_unlock_achievement',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_unlock_achievement', // 单次消耗
        key: 'time_attr_cost_per_unlock_achievement', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_unlock_achievement',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_unlock_achievement_per_install', // 频率
        key: 'time_attr_unlock_achievement_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_unlock_achievement_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_unlock_achievement', // 次数
        key: 'time_attr_repetitive_unlock_achievement', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_unlock_achievement',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_unlock_achievement', // 单次消耗
        key: 'time_attr_cost_per_repetitive_unlock_achievement', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_unlock_achievement',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_unlock_achievement', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_unlock_achievement', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_unlock_achievement',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_unlock_achievement_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_unlock_achievement_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_unlock_achievement_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_sales_lead', // 事件父节点
    key: 'event_sales_lead', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_sales_lead',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_sales_lead_count', // 次数
        key: 'time_attr_sales_lead', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_sales_lead',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_sales_lead', // 单次消耗
        key: 'time_attr_cost_per_sales_lead', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_sales_lead',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_sales_lead_per_install', // 频率
        key: 'time_attr_sales_lead_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_sales_lead_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_sales_lead', // 次数
        key: 'time_attr_repetitive_sales_lead', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_sales_lead',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_sales_lead', // 单次消耗
        key: 'time_attr_cost_per_repetitive_sales_lead', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_sales_lead',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_sales_lead', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_sales_lead', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_sales_lead',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_sales_lead_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_sales_lead_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_sales_lead_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_in_app_ad_click', // 事件父节点
    key: 'event_in_app_ad_click', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_ad_click',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_ad_click_count', // 次数
        key: 'time_attr_in_app_ad_click', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_in_app_ad_click',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_in_app_ad_click', // 单次消耗
        key: 'time_attr_cost_per_in_app_ad_click', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_in_app_ad_click',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_ad_click_per_install', // 频率
        key: 'time_attr_in_app_ad_click_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_in_app_ad_click_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_in_app_ad_click', // 次数
        key: 'time_attr_repetitive_in_app_ad_click', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_in_app_ad_click',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_in_app_ad_click', // 单次消耗
        key: 'time_attr_cost_per_repetitive_in_app_ad_click', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_in_app_ad_click',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_in_app_ad_click', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_in_app_ad_click', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_in_app_ad_click',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_in_app_ad_click_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_in_app_ad_click_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_in_app_ad_click_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_in_app_ad_impr', // 事件父节点
    key: 'event_in_app_ad_impr', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_in_app_ad_impr',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_ad_impr_count', // 次数
        key: 'time_attr_in_app_ad_impr', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_in_app_ad_impr',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_in_app_ad_impr', // 单次消耗
        key: 'time_attr_cost_per_in_app_ad_impr', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_in_app_ad_impr',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_in_app_ad_impr_per_install', // 频率
        key: 'time_attr_in_app_ad_impr_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_in_app_ad_impr_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_in_app_ad_impr', // 次数
        key: 'time_attr_repetitive_in_app_ad_impr', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_in_app_ad_impr',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_in_app_ad_impr', // 单次消耗
        key: 'time_attr_cost_per_repetitive_in_app_ad_impr', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_in_app_ad_impr',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_in_app_ad_impr', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_in_app_ad_impr', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_in_app_ad_impr',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_in_app_ad_impr_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_in_app_ad_impr_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_in_app_ad_impr_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_loan_apply', // 事件父节点
    key: 'event_loan_apply', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_loan_apply',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_loan_apply_count', // 次数
        key: 'time_attr_loan_apply', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_loan_apply',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_loan_apply', // 单次消耗
        key: 'time_attr_cost_per_loan_apply', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_loan_apply',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_loan_apply_per_install', // 频率
        key: 'time_attr_loan_apply_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_loan_apply_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_loan_apply', // 次数
        key: 'time_attr_repetitive_loan_apply', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_loan_apply',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_loan_apply', // 单次消耗
        key: 'time_attr_cost_per_repetitive_loan_apply', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_loan_apply',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_loan_apply', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_loan_apply_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_loan_credit', // 事件父节点
    key: 'event_loan_credit', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_loan_credit',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_loan_credit_count', // 次数
        key: 'time_attr_loan_credit', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_loan_credit',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_loan_credit', // 单次消耗
        key: 'time_attr_cost_per_loan_credit', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_loan_credit',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_loan_credit_per_install', // 频率
        key: 'time_attr_loan_credit_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_loan_credit_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_loan_credit', // 次数
        key: 'time_attr_repetitive_loan_credit', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_loan_credit',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_loan_credit', // 单次消耗
        key: 'time_attr_cost_per_repetitive_loan_credit', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_loan_credit',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_loan_credit', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_loan_credit_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_loan_completion', // 事件父节点
    key: 'event_loan_completion', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_loan_completion',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_loan_completion_count', // 次数
        key: 'time_attr_loan_completion', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_loan_completion',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_loan_completion', // 单次消耗
        key: 'time_attr_cost_per_loan_completion', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_loan_completion',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_loan_completion_per_install', // 频率
        key: 'time_attr_loan_completion_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_loan_completion_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_loan_completion', // 次数
        key: 'time_attr_repetitive_loan_completion', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_loan_completion',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_loan_completion', // 单次消耗
        key: 'time_attr_cost_per_repetitive_loan_completion', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_loan_completion',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_loan_completion', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_loan_completion_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_login', // 事件父节点
    key: 'event_login', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_login',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_login_count', // 次数
        key: 'time_attr_login', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_login',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_login', // 单次消耗
        key: 'time_attr_cost_per_login', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_login',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_login_per_install', // 频率
        key: 'time_attr_login_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_login_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_login', // 次数
        key: 'time_attr_repetitive_login', // {metric}
        hint: 'campaign_hover_stat_data.repetitive_login',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_login', // 单次消耗
        key: 'time_attr_cost_per_repetitive_login', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_login',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_login', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_login_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_rate', // 事件父节点
    key: 'event_rate', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_rate',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_rate_count', // 次数
        key: 'time_attr_rate', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_rate',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_rate', // 单次消耗
        key: 'time_attr_cost_per_rate', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_rate',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_rate_per_install', // 频率
        key: 'time_attr_rate_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_rate_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_rate', // 次数
        key: 'time_attr_repetitive_rate', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_rate',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_rate', // 单次消耗
        key: 'time_attr_cost_per_repetitive_rate', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_rate',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_rate', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_rate', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_rate',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_rate_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_rate_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_rate_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_search', // 事件父节点
    key: 'event_search', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_search',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_search_count', // 次数
        key: 'time_attr_search', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_search',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_search', // 单次消耗
        key: 'time_attr_cost_per_search', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_search',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_search_per_install', // 频率
        key: 'time_attr_search_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_search_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_search', // 次数
        key: 'time_attr_repetitive_search', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_search',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_search', // 单次消耗
        key: 'time_attr_cost_per_repetitive_search', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_search',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_search', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_search_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_start_trial', // 事件父节点
    key: 'event_start_trial', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_start_trial',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_start_trial_count', // 次数
        key: 'time_attr_start_trial', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_start_trial',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_start_trial', // 单次消耗
        key: 'time_attr_cost_per_start_trial', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_start_trial',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_start_trial_per_install', // 频率
        key: 'time_attr_start_trial_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_start_trial_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_start_trial', // 次数
        key: 'time_attr_repetitive_start_trial', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_start_trial',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_start_trial', // 单次消耗
        key: 'time_attr_cost_per_repetitive_start_trial', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_start_trial',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        key: 'time_attr_value_per_start_trial', // value_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_total_start_trial_value', // total_{metric}_value
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_in_app_event_subscribe', // 事件父节点
    key: 'event_subscribe', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_subscribe',
    children: [
      {
        i18nPath: 'common_in_app_event_time_attr_subscribe_count', // 次数
        key: 'time_attr_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_subscribe',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_subscribe', // 单次消耗
        key: 'time_attr_cost_per_subscribe', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_subscribe',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_subscribe_per_install', // 频率
        key: 'time_attr_subscribe_per_install', // {metric}_per_install
        hint: 'campaign_hover_stat_data.time_attr_subscribe_per_install',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_app_event_time_attr_repetitive_subscribe', // 次数
        key: 'time_attr_repetitive_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_repetitive_subscribe',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_app_event_time_attr_cost_per_repetitive_subscribe', // 单次消耗
        key: 'time_attr_cost_per_repetitive_subscribe', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_repetitive_subscribe',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_value_per_repetitive_subscribe', // 每个Event的平均价值
        key: 'time_attr_value_per_repetitive_subscribe', // value_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_value_per_repetitive_subscribe',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_app_event_time_attr_total_repetitive_subscribe_value', // 总付费价值 / 100000
        key: 'time_attr_total_repetitive_subscribe_value', // total_{metric}_value
        hint: 'campaign_hover_stat_data.time_attr_total_repetitive_subscribe_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
];
